import styled from 'styled-components';
import { Palette } from 'config';

export const Wrap = styled.div`
  display: flex;
  flex-wrap: ${({ showProgressBar }) => (showProgressBar ? 'wrap' : 'nowrap')};
  gap: 16px;
  row-gap: 12px;
  align-items: center;
  padding: 16px 0;
  padding-bottom: ${({ showProgressBar }) => (showProgressBar ? '0' : '16px')};
  max-height: 73px;
  border-bottom: ${({ showProgressBar }) =>
    `1px solid ${showProgressBar ? 'transparent' : Palette.PrimaryGray._200}`};

  [data-index]:last-child > &:last-child {
    border-bottom: 0;
  }
`;

export const AppIcon = styled.img`
  width: 40px;
  height: 40px;
  background-color: lightgray;
  flex-shrink: 0;
  border-radius: 4px;
`;

export const Info = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;

  & > p {
    color: ${Palette.PrimaryGray._700};
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    min-height: 20px;
  }
`;

export const IdLine = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  color: ${Palette.PrimaryGray._500};
  font-size: 12px;
  line-height: 16px;
`;

export const MetricValue = styled.div`
  display: flex;
  flex-shrink: 0;
  white-space: nowrap;
  align-items: center;
  gap: 4px;
  color: ${Palette.PrimaryGray._900};
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  margin-bottom: auto;
  margin-top: 2px;
`;

export const EventValue = styled.div`
  min-width: 34px;
  flex-shrink: 0;
  color: ${Palette.PrimaryGray._500};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: right;
`;

export const Trend = styled.span`
  flex-shrink: 0;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: ${({ direction }) =>
    direction === 'down' ? '0' : `6px solid ${Palette.Teal._500}`};
  border-top: ${({ direction }) => (direction === 'down' ? `6px solid ${Palette.Red._500}` : '0')};
  opacity: ${({ direction }) => (direction ? '1' : '0')};
  margin-left: 2px;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  overflow: hidden;
  background: ${Palette.PrimaryGray._100};

  &::before {
    content: '';
    display: block;
    width: ${({ progressValue }) => `${Math.min(Math.max(progressValue, 0), 1) * 100}%`};
    height: 100%;
    border-radius: inherit;
    background: ${({ direction }) =>
      direction === 'down' ? Palette.Red._300 : Palette.Primary._200};
  }
`;
